export const relationshipOptions = [
  {
    label: "Account Holder",
    value: "account_holder_relationship_to_acc_v2",
  },
  {
    label: "Power of Attorney",
    value: "power_of_attorney_relationship_to_acc_v2",
  },
] as const;

export const actionOptions = [
  { label: "Add", value: "add" },
  { label: "Remove", value: "remove" },
] as const;

export const authorityLevelOptions = [
  {
    label: "Authority to Disclose",
    value: "authority_to_disclose",
  },
  {
    label: "Authority to Maintain",
    value: "authority_to_maintain",
  },
] as const;

export const removalTypeOptions = [
  {
    label: "Organisation or Financial Counsellor",
    value: "yes_remove",
  },
  {
    label:
      "Court appointed authority such as a Guardian or Legally Appointed Administrator",
    value: "no_remove",
  },
  {
    label: "Nominated third party ",
    value: "nominated_third_party_",
  },
] as const;

export const primaryContactOptions = [
  {
    label: "Myself",
    value: "myself",
  },
  {
    label: "My nominated third party",
    value: "my_nominated_third_party_",
  },
] as const;
